export interface AddWalletMovementInterface {
  contactId: number;
  walletId: number | null;
  type: 'credit' | 'debit';
  amount: number;
  paymentMethodType: string;
  description: string | null;
}

export type AddWalletMovementKeys = keyof AddWalletMovementInterface;
export type AddWalletMovementErrorObject = Partial<Record<AddWalletMovementKeys, string[]>>;

export const addWalletMovementConfig = {
  wallet_name: {
    fieldPath: 'wallet_name',
    fieldReadPath: 'wallet_name',
    name: 'wallet_name',
    label: 'virtual_wallet.wallet.name.add_movement_label',
    id: 'wallet_movement__wallet_name',
    rules: [],
    options: [],
    warningRules: [],
    veeValidation: false,
  },
  balance: {
    fieldPath: 'balance',
    fieldReadPath: 'balance',
    name: 'balance',
    label: 'virtual_wallet.wallet.balance.label',
    options: [],
    id: 'wallet_movement__balance',
    rules: [],
    appendIcon: 'euro-sign',
    fieldAttributes: {
      autocomplete: 'off',
      type: 'number',
      step: '0.01',
    },
    warningRules: [],
    veeValidation: false,
  },
  amount: {
    fieldPath: 'amount',
    fieldReadPath: 'amount',
    name: 'amount',
    label: 'virtual_wallet.wallet_movements.amount.amount.label',
    options: [],
    id: 'wallet_movement__amount',
    rules: ['required', 'numeric', 'decimal:0,2'],
    appendIcon: 'euro-sign',
    fieldAttributes: {
      autocomplete: 'off',
      type: 'number',
      step: '.01',
    },
    warningRules: [],
    veeValidation: false,
  },
  type: {
    fieldPath: 'type',
    fieldReadPath: 'type',
    name: 'type',
    label: 'virtual_wallet.wallet_movements.type.label',
    id: 'wallet_movement__type',
    rules: ['required', 'in:credit,debit'],
    options: [
      {
        text: 'virtual_wallet.wallet_movements.fields.type.credit.label',
        value: 'credit',
      },
      {
        text: 'virtual_wallet.wallet_movements.fields.type.debit.label',
        value: 'debit',
      },
    ],
  },
  description: {
    fieldPath: 'description',
    fieldReadPath: 'description',
    name: 'description',
    label: 'virtual_wallet.wallet_movements.description.label',
    id: 'wallet_movement__description',
    rules: ['required', 'max:255'],
    options: [],
    warningRules: [],
    veeValidation: false,
  },
  paymentMethodType: {
    fieldPath: 'payment_method_type',
    fieldReadPath: 'payment_method_type',
    name: 'payment_method_type',
    label: 'global.payment_method_type.label',
    defaultValue: 'money_transfer',
    options: [
      {
        text: 'global.payment.cash',
        value: 'cash',
      },
      {
        text: 'global.payment.money_transfer',
        value: 'money_transfer',
      },
      {
        text: 'global.payment.manual_terminal',
        value: 'manual_terminal',
      },
      {
        text: 'global.payment.cheque',
        value: 'cheque',
      },
      {
        text: 'global.payment.sport_cheque',
        value: 'sport_cheque',
      },
      {
        text: 'global.payment.sodexo_cheque',
        value: 'sodexo_cheque',
      },
      {
        text: 'global.payment.clearance',
        value: 'clearance',
      },
      {
        text: 'global.payment.direct_debit',
        value: 'direct_debit',
      },

      {
        text: 'global.payment.custom_2',
        value: 'custom_2',
      },

      {
        text: 'global.payment.custom_4',
        value: 'custom_4',
      },
      {
        text: 'global.payment.custom_5',
        value: 'custom_5',
      },

      {
        text: 'global.payment.custom_8',
        value: 'custom_8',
      },
      {
        text: 'global.payment.custom_9',
        value: 'custom_9',
      },
      {
        text: 'global.payment.custom_10',
        value: 'custom_10',
      },
    ],
    id: 'wallet_movement__payment-method-type',
    rules: ['required'],
  },
  paymentMethodTypeFR: {
    fieldPath: 'payment_method_type',
    fieldReadPath: 'payment_method_type',
    name: 'payment_method_type',
    label: 'virtual_wallet.wallet_movements.payment_method_type.label',
    defaultValue: 'money_transfer',
    options: [
      {
        text: 'global.payment.cash',
        value: 'cash',
      },
      {
        text: 'global.payment.money_transfer',
        value: 'money_transfer',
      },
      {
        text: 'global.payment.manual_terminal',
        value: 'manual_terminal',
      },
      {
        text: 'global.payment.cheque',
        value: 'cheque',
      },
      {
        text: 'global.payment.sport_cheque',
        value: 'sport_cheque',
      },
      {
        text: 'global.payment.sodexo_cheque',
        value: 'sodexo_cheque',
      },
      {
        text: 'global.payment.clearance',
        value: 'clearance',
      },
      {
        text: 'global.payment.direct_debit',
        value: 'direct_debit',
      },
      // Only FR
      {
        text: 'global.payment.custom_1',
        value: 'custom_1',
      },
      {
        text: 'global.payment.custom_2',
        value: 'custom_2',
      },
      // Only FR
      {
        text: 'global.payment.custom_3',
        value: 'custom_3',
      },
      {
        text: 'global.payment.custom_4',
        value: 'custom_4',
      },
      {
        text: 'global.payment.custom_5',
        value: 'custom_5',
      },
      // Only FR
      {
        text: 'global.payment.custom_6',
        value: 'custom_6',
      },
      // Only FR
      {
        text: 'global.payment.custom_7',
        value: 'custom_7',
      },
      {
        text: 'global.payment.custom_8',
        value: 'custom_8',
      },
      {
        text: 'global.payment.custom_9',
        value: 'custom_9',
      },
      {
        text: 'global.payment.custom_10',
        value: 'custom_10',
      },
      {
        text: 'global.payment.custom_11',
        value: 'custom_11',
      },
      {
        text: 'global.payment.custom_12',
        value: 'custom_12',
      },
    ],
    id: 'wallet_movement__payment-method-type',
    rules: ['required'],
  },
};
